'use strict';

var ClassUtil = function() {};

//recursively merge one Object into another
ClassUtil.merge = function(destination, source) {
	for (var p in source) {
		try {
			// Property in destination object set; update its value.
			if ( source[p].constructor==Object ) {
				destination[p] = ClassUtil.merge(destination[p], source[p]);
			} 
			else {
				destination[p] = source[p];
			}
		} 
		catch(e) {
			// Property in destination object not set; create it and set its value.
			destination[p] = source[p];
		}
	}		
	return destination;
};

//Node module export
if (typeof exports !== 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
        exports = module.exports = ClassUtil;
    }
    exports.ClassUtil = ClassUtil;
}